import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { WebApiURL } from "../../Constants/Constants";

function UsesrRoles() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(`${WebApiURL}Verification/Users`);
      setUsers(res.data.filter((u) => u.status !== 0)); // Exclude status 0
    } catch (err) {
      console.error("Error fetching users:", err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to load users. Please try again later.",
      });
    }
  };

  const handleRoleChange = async (userId, newRole) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to change this user's role to "${newRole}".`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
      cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) return;

    try {
      await axios.put(`${WebApiURL}Verification/ChangeRole`, {
        userId, // Pass user ID instead of email
        role: newRole,
      });

      await fetchUsers(); // Refresh the user list

      Swal.fire({
        icon: "success",
        title: "Role Updated!",
        text: `The user's role has been successfully changed to "${newRole}".`,
        toast: true,
        position: "top-end",
        timer: 2000,
        showConfirmButton: false,
        background: "#f0f9eb",
        color: "#155724",
        iconColor: "#28a745",
      });
    } catch (err) {
      console.error("Error updating role:", err);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Could not update user role. Please try again later.",
        toast: true,
        position: "top-end",
        timer: 2500,
        showConfirmButton: false,
      });
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return { text: "Active", color: "green" };
      case 2:
        return { text: "Terminated", color: "orange" };
      case 3:
        return { text: "Declined", color: "red" };
      default:
        return { text: "Pending", color: "blue" };
    }
  };

  return (
    <div className="container mt-4">
      <h2>User Management</h2>
      <table className="table table-bordered table-striped mt-3">
        <thead>
          <tr>
            <th>Selected</th>
            <th>Full Name</th>
            <th>Surname</th>
            <th>Email</th>
            <th>Type of User</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {users.length ? (
            users.map((user) => {
              const { text, color } = getStatusText(user.status);
              return (
                <tr key={user.id}>
                  <td><input type="checkbox" /></td>
                  <td>{user.fullName}</td>
                  <td>{user.surname}</td>
                  <td>{user.email}</td>
                  <td>
                    <select
                      value={user.role}
                      onChange={(e) =>
                        handleRoleChange(user.id, e.target.value)
                      }
                      className="form-select form-select-sm"
                    >
                      <option value="NormalUser">NormalUser</option>
                      <option value="Admin">Admin</option>
                      <option value="Terminated">Terminated</option>
                    </select>
                  </td>
                  <td style={{ color, fontWeight: "bold" }}>{text}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No users found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default UsesrRoles;
